import React, { useRef } from 'react'
import media, { mediaMax } from 'styles/media'
import LazyImage from 'components/display/LazyImage'
import styled from 'styled-components'
import AppStore from './Badges/AppStore'
import GooglePlay from './Badges/GooglePlay'
import Header, {
  ChildrenWrapper,
  Content,
} from '../../components/landing/Header'
import ScrollTop from '../../components/utils/ScrollTop'

export const headerImage = {
  medium: {
    width: 620,
    url:
      'https://assets.riparide.com/landing_pages/download_app/header/medium-3a0a4c985a192e107ce39db945177485.jpg',
  },
  large: {
    width: 1290,
    url:
      'https://assets.riparide.com/landing_pages/download_app/header/large-7a83a9e39c1a87b945967b30bccd7ec4.jpg',
  },
  hero: {
    width: 1300,
    url:
      'https://assets.riparide.com/landing_pages/download_app/header/hero-eaa95bc51f57ddf95d5bf622b75a703b.jpg',
  },
}

const Wrapper = styled.div`
  margin-bottom: 84px;

  h1 {
    color: ${({ theme }) => theme?.['-ds-core-400']?.value};
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-xxl']?.['font-size']?.value};
    font-weight: 500;
    line-height: 1.2;
    margin-bottom: 0;

    ${media.md`
      font-size: ${({ theme }) =>
        theme?.['-ds-font-size-xxxl']?.['font-size']?.value};
    `};
  }
  h2 {
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-xl']?.['font-size']?.value};
    font-weight: 500;
    color: ${({ theme }) => theme?.['-ds-core-400']?.value};
    line-height: 1.3;
    margin-bottom: 16px;

    ${media.md`
      font-size: ${({ theme }) =>
        theme?.['-ds-font-size-xxl']?.['font-size']?.value};
    `};
  }
  h3 {
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-md']?.['font-size']?.value};
    font-weight: 400;
    color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
    line-height: 1.4;
    margin-bottom: 32px;

    ${media.md`
      font-size: ${({ theme }) =>
        theme?.['-ds-font-size-lg']?.['font-size']?.value};
      margin-bottom: 56px;
    `};
  }

  ${Content} {
    padding: 32px;
  }

  ${ChildrenWrapper} {
    min-height: 400px;
  }
`

const Screenshot = styled.div`
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 392px;
  transform: translate(-50%);
  margin: 0 auto;

  ${mediaMax.md`
    width: 288px;
  `}
`

const Badges = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  gap: 16px;
  margin-bottom: 0;

  svg {
    height: 56px;
    width: auto;
  }

  a {
    margin: 0;
  }
`

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(3px);
`

const DownloadApp = () => {
  const headerImgEl = useRef<HTMLImageElement>()

  return (
    <Wrapper>
      <ScrollTop />
      <Header
        h2Text="Tap into nature"
        h3Text="with the Riparide app"
        cta={
          <>
            <h3>Unique stays paired with fulfilling, local experiences.</h3>
            <Badges>
              <a href="https://apps.apple.com/app/apple-store/id6471192765?pt=126628018&ct=riparide.com-download&mt=8">
                <AppStore />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.riparide.android">
                <GooglePlay />
              </a>
            </Badges>
          </>
        }
      >
        <LazyImage
          ref={headerImgEl}
          data-src={headerImage.large.url}
          data-srcset={`
              ${headerImage.medium.url} ${headerImage.medium.width}w,
              ${headerImage.large.url} ${headerImage.large.width}w,
              ${headerImage.hero.url} ${headerImage.hero.width}w,
            `}
          preload
        />
        <Overlay />
        <Screenshot>
          <LazyImage data-src="https://assets.riparide.com/landing_pages/download_app/phone-8a37fa7e.png" />
        </Screenshot>
      </Header>
    </Wrapper>
  )
}

export default DownloadApp
